import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import {
    createAnnotation,
    deleteAnnotation,
    getTaskAnnotations,
    setPageNumber,
    updateAnnotation,
} from '../actions/annotations.actions';
import { CreateAnnotationDto } from '../dtos/create-annotation-dto.interface';
import { UpdateAnnotationDto } from '../dtos/update-annotation-dto.interface';
import { Annotation } from '../interfaces/annotation.interface';
import * as fromFeature from '../reducers/annotations.reducer';

@Injectable()
export class AnnotationsProvider {
    constructor(protected store: Store<fromFeature.AppState>) {}

    public dispatchGetTaskAnnotations(taskId: string, page: number = 1, limit: number = 50): void {
        return this.store.dispatch(getTaskAnnotations.do({ payload: { taskId, page, limit } }));
    }

    public getTaskAnnotations$(): Observable<Annotation[]> {
        return this.store.pipe(select(fromFeature.selectTaskAnnotations));
    }

    public getTaskAnnotationsCount$(): Observable<number> {
        return this.store.pipe(select(fromFeature.selectTotalCount));
    }

    public dispatchCreateAnnotation(taskId: string, payload: CreateAnnotationDto): void {
        return this.store.dispatch(createAnnotation.do({ payload: { taskId, payload } }));
    }

    public dispatchUpdateAnnotation(annotationId: string, payload: UpdateAnnotationDto): void {
        return this.store.dispatch(updateAnnotation.do({ annotationId, payload }));
    }

    public dispatchDeleteAnnotation(annotationId: string): void {
        return this.store.dispatch(deleteAnnotation.do({ payload: annotationId }));
    }

    public setPageNumber(page: number): void {
        return this.store.dispatch(setPageNumber({ payload: page }));
    }

    public getPageNumber$(): Observable<number> {
        return this.store.pipe(select(fromFeature.selectPageNumber));
    }
}
